// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__nfHlH","fadeOut":"loader_fadeOut__FlERZ","show":"loader_show__LB-ka"};